import { Pipe, PipeTransform } from '@angular/core';

/**
 * @deprecated This pipe is obsolete and should not be used in new code.
 */

@Pipe({
  name: 'getFromId',
  standalone: true,
  pure: true,
})
export class GetFromIdPipe implements PipeTransform {
  transform<T extends { id: number }>(items: T[], id: number): T {
    return items?.find((item) => item.id === id);
  }
}
